import WebComponent from '../base/WebComponent';

// A base for webcomponents
export default class WIcons extends WebComponent {
    static observedAttrs = ["name", "color", "width", "height", "class", "viewBox"];

    render() {
        this.innerHTML = `
			<svg 
				xmlns="http://www.w3.org/2000/svg" 
				viewBox="${this.viewBox ? this.viewBox : '0 0 24 24'}"
				width="${this.width ? this.width : "1em"}"
                height="${this.height ? this.height : "1em"}"
				fill="${this.color ? this.color : "currentColor"}"
				class="${this.class ? this.class : ""}"
			>
                ${this.contents}
			</svg>
		`;
    }
}
customElements.define( 'w-icon', WIcons );